import { CoreCapsule, PREFIX as STORAGE_PREFIX, PregenIdentifierType, isWalletSupported } from './CoreCapsule.js';
export { EmailTheme, WalletType, WalletScheme, OnRampPurchaseType, NON_ED25519, } from '@usecapsule/user-management-client';
export * from './definitions.js';
export * from './types/index.js';
export { distributeNewShare } from './shares/shareDistribution.js';
export { KeyContainer } from './shares/KeyContainer.js';
export { RecoveryStatus, stringToPhoneNumber, entityToWallet } from './CoreCapsule.js';
export { initClient } from './external/capsuleClient.js';
import * as mpcComputationClient_1 from './external/mpcComputationClient.js';
export { mpcComputationClient_1 as mpcComputationClient };
export { getBaseUrl } from './external/capsuleClient.js';
export { decryptWithKeyPair, decryptWithPrivateKey, getAsymmetricKeyPair, getPublicKeyHex, encryptWithDerivedPublicKey, encodePrivateKeyToPemHex, getDerivedPrivateKeyAndDecrypt, getPublicKeyFromSignature, getSHA256HashHex, encryptPrivateKey, decryptPrivateKey, decryptPrivateKeyAndDecryptShare, hashPasswordWithSalt, encryptPrivateKeyWithPassword, decryptPrivateKeyWithPassword, publicKeyFromHex, } from './cryptography/utils.js';
export * from './external/capsuleClient.js';
export * from './utils/pollingUtils.js';
export * from './errors.js';
export * from './utils/formattingUtils.js';
export { retrieve as transmissionUtilsRetrieve } from './transmission/transmissionUtils.js';
export { STORAGE_PREFIX, PregenIdentifierType, isWalletSupported };
export const capsuleVersion = CoreCapsule.version;
export default CoreCapsule;
